<section class="components" [class.components--focused-work]="scope === 'work' && !overview" [class.components--forms-work]="scope === 'work' && !overview && contextualWorkHeader && workLibraryKind === 'form'" aria-label="Step components">
  <header *ngIf="scope === 'work' && contextualWorkHeader && !overview" class="work-context-heading">
    <button uiButton [size]="undefined" [text]="true" [outlined]="workLibraryKind !== 'form'" type="button" (click)="formActionSettings ? backToWorkForm() : requestWorkOverview()"><i *ngIf="workLibraryKind === 'form'" class="pi pi-arrow-left" aria-hidden="true"></i> {{ formActionSettings && selectedCommand ? label(selectedCommand) + ' form' : 'Work overview' }}</button>
    <h3 tabindex="-1" data-owner-focus="work-selection">{{ workContextTitle }}</h3>
    <label *ngIf="workLibraryKind === 'form' && !formActionSettings && workFormCommands.length" class="work-form-picker">Form
      <select uiControl aria-label="Form to edit" #workFormSelect [ngModel]="selection.kind === 'form' ? selection.commandId : ''"
        (ngModelChange)="selectWorkForm($event, workFormSelect)" [disabled]="loading">
        <option *ngFor="let form of workFormCommands; trackBy: trackCommand" [value]="identity(form)">{{ formTitle(form) }}</option>
      </select>
    </label>
    <button uiButton [size]="undefined" [outlined]="true" type="button" class="work-context-add" *ngIf="!formActionSettings" [disabled]="disabled || loading || workEditingUnavailable || !!catalogError" (click)="selectLibrary(workLibraryKind)"><i *ngIf="workLibraryKind === 'form'" class="pi pi-plus" aria-hidden="true"></i> Add {{ workLibraryKind === 'form' ? 'form' : 'action' }}</button>
  </header>
  <phms-workflow-library-selector
    title="Add action" description="Choose an operation and see how it fits this step." searchLabel="Search actions" allCategoryLabel="All actions"
    [categories]="actionCategories" [entries]="actionLibraryEntries" [open]="actionLibraryOpen" [active]="active && !overview && scope === 'work'"
    [context]="actionLibraryRenderContext()" [disabled]="disabled || workEditingUnavailable || !!catalogError" [loading]="loading" [error]="catalogError"
    emptyMessage="No additional actions are available for this step." footerMessage="Data-entry forms are added in Forms. Notice, voting and SDMF work is configured on Staff page."
    [footerActions]="actionFooterActions" (chooseRequested)="chooseActionLibrary($event)" (ownerActionRequested)="requestActionLibraryOwner($event)"
    (footerActionRequested)="requestActionLibraryFooter($event)" (opened)="actionLibraryOpened()" (closed)="actionLibraryClosed($event)" (retryRequested)="load()"
  />
  <phms-workflow-library-selector
    title="Choose a review form" description="Choose how staff record the review. Apply the form and its routes together."
    searchLabel="Search review forms" allCategoryLabel="All review forms"
    [categories]="reviewCategories" [entries]="reviewLibraryEntries" [open]="reviewLibraryOpen" [active]="active && !overview"
    [context]="reviewLibraryRenderContext()" [disabled]="disabled || workEditingUnavailable || !!catalogError" [loading]="loading" [error]="catalogError"
    emptyMessage="No compatible review forms are available for this step."
    (chooseRequested)="chooseReviewLibrary($event)" (opened)="reviewLibraryOpened()" (closed)="reviewLibraryClosed($event)"
  />
  <phms-workflow-library-selector
    title="Form library" description="Add a compatible form or edit one already on this step." searchLabel="Search forms" allCategoryLabel="All forms"
    [categories]="formCategories" [entries]="formLibraryEntries" [open]="formLibraryOpen" [active]="active && !overview && scope === 'work'"
    [context]="formLibraryRenderContext()" [disabled]="disabled || workEditingUnavailable || !!catalogError" [loading]="loading" [error]="catalogError"
    emptyMessage="No forms are available for this step." footerMessage="Record review forms come from recorded-decision setup. Notice, voting and SDMF forms belong on Staff page."
    [footerActions]="formFooterActions" (chooseRequested)="chooseFormLibrary($event)" (ownerActionRequested)="requestFormLibraryOwner($event)"
    (footerActionRequested)="requestFormLibraryFooter($event)" (opened)="formLibraryOpened()" (closed)="formLibraryClosed($event)" (retryRequested)="load()"
  />
  <phms-workflow-review-setup-dialog
    [open]="reviewSetupDialogOpen" [active]="active && !overview && scope === 'behavior'"
    [context]="reviewSetupDialogContext()" [candidate]="reviewSetupDialogModel"
    [disabled]="reviewSetupDialogDisabled" [error]="reviewSetupDialogError || reviewSetupAvailabilityIssue || routeError"
    (opened)="reviewSetupDialogOpened($event)" (closed)="reviewSetupDialogClosed($event)"
    (routeChanged)="changeReviewSetupRoute($event)" (applyRequested)="applyReviewSetupDialog($event)"
  />
  <ui-panel *ngIf="preparingReviewDecision && !reviewSetupDialogModel" data-review-setup-unavailable panelTitle="Review setup unavailable" [noGrow]="true">
    <p role="status">{{ reviewSetupDialogError || reviewSetupAvailabilityIssue }} The unapplied setup is retained; the saved step and paths have not been replaced.</p>
    <button uiButton type="button" (click)="discardRouteChanges()">Discard review setup</button>
  </ui-panel>
  <p *ngIf="loading" role="status">Loading forms and actions…</p>
  <p *ngIf="error" role="alert">
    {{ error }}
    <button
      uiButton
      *ngIf="!catalog"
      type="button"
      (click)="load()"
      [disabled]="loading"
    >
      Retry
    </button>
  </p>
  <p *ngIf="message" role="status">{{ message }}</p>
  <ng-template #providedFormSetupHeader><h3 class="action-detail-title">{{ stagedFormTitle }}</h3></ng-template>
  <ui-panel *ngIf="formSetup" [headerTemplate]="providedFormSetupHeader" [noGrow]="true">
    <div class="provided-form-setup-body" role="region" [attr.aria-label]="stagedFormName + ' form change'" tabindex="-1" data-provided-form-setup
      [attr.data-preparation-setup]="preparationSetup ? '' : null" [attr.data-direct-request-setup]="directRequestSetup ? '' : null">
    <p>Apply this form to the working draft. Existing settings and the review destination stay in place. Choose a lookup source separately in Fields.</p>
    <p *ngIf="formSetupError" role="alert">{{ formSetupError }}</p>
    <p *ngIf="!formSetupError && stagedFormPendingState() === 'stale'" role="status">The draft, author or installed forms changed. Discard this setup and choose the current {{ stagedFormName }} form again.</p>
    <p *ngIf="!formSetupError && stagedFormPendingState() === 'invalid'" role="status">Form editing is unavailable. The staged change is retained and can be discarded.</p>
    <button uiButton type="button" [outlined]="false" severity="primary" (click)="applyStagedForm()"
      [disabled]="!active || overview || stagedFormPendingState() !== 'valid'">{{ stagedFormApplyLabel }}</button>
    <button uiButton type="button" [text]="true" (click)="discardStagedForm()">Discard form change</button>
    </div>
  </ui-panel>
  <p *ngIf="workEditingUnavailable" role="status">
    This saved workflow uses an older format. Enable editing in Settings to
    change its work.
  </p>
  <p *ngIf="scope === 'work' && contextualWorkHeader && !overview && workLibraryKind === 'form' && !loading && !workFormCommands.length" role="status">No forms added.</p>
  <div
    *ngIf="
      !node.declaration &&
      !hideDashboardPicker &&
      scope !== 'behavior' &&
      !inspectorOnly
    "
    class="empty-step"
  >
    <strong>Set up this step</strong>
    <p>
      Add forms and actions, then arrange the staff page.
    </p>
    <button
      uiButton
      severity="primary"
      [outlined]="false"
      type="button"
      (click)="initialize()"
      [disabled]="disabled || loading || workEditingUnavailable"
    >
      Start with a blank step
    </button>
  </div>
  <div
    *ngIf="catalog && scope === 'behavior' && !inspectorOnly"
    class="behavior-workspace"
    aria-label="Step behavior workspace"
  >
    <header class="route-toolbar">
      <label *ngIf="hasOutcomes" class="route-action-picker">
        {{
          selectedCommand && isRecordedRouting(selectedCommand)
            ? "Use the recorded result from"
            : "When this action completes"
        }}
        <select
          uiControl
          #routeActionSelect
          aria-label="Action to route"
          [ngModel]="selection.commandId || ''"
          (ngModelChange)="selectRouteAction($event, routeActionSelect)"
        >
          <option value="" disabled>Choose an action</option>
          <option
            *ngFor="let command of routedCommands; trackBy: trackCommand"
            [value]="identity(command)"
          >
            {{ label(command) }}
          </option>
        </select>
      </label>
      <div *ngIf="!hasOutcomes" class="route-trigger">
        <span class="route-eyebrow">Routing starts after</span>
        <strong>{{ completionTrigger }}</strong>
      </div>
      <div class="route-links">
        <button
          uiButton
          [text]="true"
          [outlined]="false"
          type="button"
          data-workflow-statuses-trigger
          [disabled]="loading || (!immediateRoutingChanges && disabled)"
          (click)="showWorkflowStatuses()"
        >
          Manage workflow statuses
        </button>
        <button
          uiButton
          [text]="true"
          [outlined]="false"
          type="button"
          (click)="showActions(selectedCommand)"
        >
          Manage actions in Work
        </button>
        <button
          uiButton
          [text]="true"
          [outlined]="false"
          type="button"
          (click)="showPaths()"
        >
          Workflow paths
        </button>
      </div>
    </header>
    <section
      *ngIf="workflowStatusesOpen && immediateRoutingChanges && !externalWorkflowStatuses"
      class="routing-statuses"
      aria-label="Workflow statuses"
      tabindex="-1"
    >
      <div class="routing-statuses__actions">
        <button uiButton type="button" (click)="closeWorkflowStatuses()">
          Done with statuses
        </button>
      </div>
      <phms-workflow-status-editor
        [document]="document"
        [nodeId]="null"
        [canAuthor]="!disabled"
        [interactionBlocked]="disabled || loading || routeChangesPending()"
        [immediateChanges]="true"
        [resetVersion]="resetVersion"
        (pendingChangesChange)="onWorkflowStatusesPending($event)"
        (documentChange)="onWorkflowStatusesDocumentChange($event)"
      />
    </section>
    <section
      class="behavior-inspector"
      aria-label="Behavior settings"
      [hidden]="workflowStatusesOpen && !externalWorkflowStatuses"
    >
      <header class="inspector-heading">
        <h3>
          {{
            hasOutcomes ? "Where each result goes" : "Where this step goes next"
          }}
        </h3>
        <span *ngIf="hasPendingChanges()" class="pending-label"
          >Unapplied changes</span
        >
      </header>
      <div class="inspector-body">
        <ng-container *ngIf="selectedCommand as command">
          <ng-container *ngIf="selection.kind === 'outcomes'">
            <div *ngIf="isRecordedRouting(command)" class="route-recording-context">
              <p>Recording a result keeps this step open. After <strong>{{ completionTrigger }}</strong> passes its completion checks, the recorded result determines the path.</p>
              <p *ngIf="preparingReviewDecision" class="hint">Applying these routes also applies the chosen review form and recorded-decision requirement.</p>
              <button uiButton [text]="true" type="button" *ngIf="canChooseReviewForm(command)" data-review-setup-trigger="change"
                [disabled]="disabled || loading || workEditingUnavailable" (click)="addReviewDecision()">Choose review form</button>
            </div>
            <ng-container
              *ngIf="contract(command) as installed; else missingOutcomes"
            >
              <div
                *ngIf="routeError"
                class="route-error"
                role="alert"
                tabindex="-1"
              >
                {{ routeError }}
              </div>
              <p
                *ngIf="
                  !routeInspectionIssue(command) &&
                  !hasPendingChanges() &&
                  routeIssue(command) as issue
                "
                class="issue route-issue"
              >
                {{ issue }}
              </p>
              <p
                *ngIf="routeInspectionIssue(command) as inspectionIssue"
                class="issue route-issue"
                role="status"
              >
                {{ inspectionIssue }}
              </p>
              <p *ngIf="workflowStatusNotice" class="hint">
                {{ workflowStatusNotice }}
              </p>
              <div class="route-workspace">
                <ui-panel panelTitle="Routes" [noGrow]="true" class="route-list-panel">
                  <nav aria-label="Result routes" class="route-list">
                    <button uiButton [wrap]="true" [text]="true" [outlined]="false" type="button"
                      *ngFor="let row of outcomes(command); let index = index; trackBy: trackRouteRow"
                      class="route-list-row" [class.route-list-row--selected]="isOutcomeSelected(command, row.code)"
                      [attr.data-route-code]="row.code" [attr.aria-label]="'Show ' + (row.label || row.code) + ' route'"
                      [attr.aria-pressed]="isOutcomeSelected(command, row.code)" [disabled]="!outcomeIdentityAvailable(command, row.code)"
                      (click)="selectOutcome(command, row.code)">
                      <span class="route-list-row__text"><strong>{{ row.label || row.code }}</strong>
                        <span>{{ outcomeReturns(command).has(row.code) ? 'Return to' : 'Continue to' }} {{ outcomeDestination(command, row).label }}</span>
                        <small *ngIf="!row.destinationNodeId">Needs a destination</small>
                        <small *ngIf="!outcomeIdentityAvailable(command, row.code)">Duplicate result identity; inspect workflow paths</small>
                      </span>
                    </button>
                  </nav>
                </ui-panel>
                <ng-container *ngIf="selectedOutcome(command) as outcome; else unavailableOutcome">
                  <ng-template #selectedRouteHeader><h4 class="route-detail-title">{{ outcome.label || outcome.code }}</h4></ng-template>
                  <ui-panel [headerTemplate]="selectedRouteHeader" [noGrow]="true" class="route-detail-panel">
                    <div class="route-detail-body">
              <fieldset
                class="outcome"
                [attr.data-outcome-code]="outcome.code"
                [disabled]="
                  disabled ||
                  loading ||
                  workEditingUnavailable ||
                  workflowStatusesPending() ||
                  !!routeInspectionIssue(command)
                "
              >
                <legend class="visually-hidden">
                  {{ outcome.label || outcome.code }} route
                </legend>
                <ng-container
                  *ngIf="outcomeDestination(command, outcome) as destination"
                >
                  <details class="route-label-setting">
                    <summary>Result label</summary>
                    <label>Display label
                      <input uiControl #resultLabelModel="ngModel" [attr.aria-label]="outcome.code + ' label'" [ngModel]="outcome.label"
                        (ngModelChange)="updateSelectedOutcome(command, outcome.code, 'label', $event, resultLabelModel)"
                        (blur)="commitRoutingChange()" (keydown.enter)="commitRoutingChange(); $event.preventDefault()" maxlength="120" />
                    </label>
                  </details>
                  <p *ngIf="pendingSavedPath(command, outcome.code) as savedPath" class="route-saved-path">Saved path: {{ savedPath }}. This route edit has not been applied.</p>
                  <div class="route-controls">
                    <label
                      >Movement
                      <select
                        uiControl
                        #movementModel="ngModel"
                        [attr.aria-label]="outcome.code + ' movement'"
                        [ngModel]="
                          outcomeReturns(command).has(outcome.code)
                            ? 'return'
                            : 'forward'
                        "
                        (ngModelChange)="
                          changeSelectedReturn(command, outcome.code, $event, movementModel)
                        "
                      >
                        <option value="forward">Continue forward</option>
                        <option value="return">Return to earlier work</option>
                      </select>
                    </label>
                    <label class="destination"
                      >{{
                        outcomeReturns(command).has(outcome.code)
                          ? "Work step to revisit"
                          : "Destination"
                      }}
                      <select
                        uiControl
                        class="destination-select" #destinationModel="ngModel"
                        [attr.aria-label]="outcome.code + ' goes to'"
                        [ngModel]="outcome.destinationNodeId"
                        (ngModelChange)="
                          updateSelectedOutcome(command, outcome.code, 'destinationNodeId', $event, destinationModel)
                        "
                      >
                        <option value="" disabled>{{ outcomeReturns(command).has(outcome.code) ? 'Choose a work step for this return' : 'Choose destination' }}</option>
                        <option
                          *ngIf="hasUnavailableDestination(command, outcome)"
                          [value]="outcome.destinationNodeId"
                          disabled
                        >
                          {{
                            unavailableDestinationLabel(
                              outcome.destinationNodeId
                            )
                          }}
                        </option>
                        <option
                          *ngFor="
                            let target of outcomeDestinations(
                              command,
                              outcome.code
                            )
                          "
                          [value]="target.id"
                        >
                          {{ destinationLabel(target.id) }}
                        </option>
                      </select>
                    </label>
                  </div>
                  <label *ngIf="installed.completesStep !== false">Reason
                    <select uiControl #reasonModel="ngModel" [attr.aria-label]="outcome.code + ' reason'" [ngModel]="outcome.reasonPolicy"
                      (ngModelChange)="changeSelectedReasonPolicy(command, outcome.code, $event, reasonModel)">
                      <option *ngFor="let policy of reasonPolicies(installed, outcome.code)" [value]="policy">{{ policy === 'required' ? 'Required' : 'Optional' }}</option>
                    </select>
                  </label>
                  <details class="outcome-status-setting">
                    <summary>Workflow status when this path is followed</summary>
                    <p class="hint">This optional override applies when the path is followed after completion. No override leaves other automatic status rules in effect.</p>
                    <label
                      >Workflow status
                      <select
                        uiControl
                        class="outcome-status-select" #statusModel="ngModel"
                        [attr.aria-label]="outcome.code + ' workflow status'"
                        [ngModel]="outcomeWorkflowStatus(command, outcome.code)"
                        (ngModelChange)="
                          changeSelectedOutcomeStatus(command, outcome.code, $event, statusModel)
                        "
                      >
                        <option value="">No outcome override</option>
                        <option
                          *ngIf="
                            unavailableOutcomeWorkflowStatus(
                              command,
                              outcome.code
                            ) as unavailableStatus
                          "
                          [value]="unavailableStatus"
                          disabled
                        >
                          Unavailable status: {{ unavailableStatus }}
                        </option>
                        <option
                          *ngFor="let status of workflowStatusChoices"
                          [value]="status.code"
                        >
                          {{ status.label }}
                        </option>
                      </select>
                    </label>
                    <p *ngIf="!workflowStatusChoices.length" class="hint">
                      Add statuses with Manage workflow statuses.
                    </p>
                    <p
                      *ngIf="
                        outcomeWorkflowStatusError(outcome.code) as statusError
                      "
                      class="issue"
                      role="alert"
                    >
                      {{ statusError }}
                    </p>
                  </details>
                  <div
                    class="return-shortcut"
                    *ngIf="
                      previousStepChoices.length &&
                      !outcomeReturns(command).has(outcome.code)
                    "
                  >
                    <button
                      uiButton
                      type="button"
                      (click)="returnSelectedToPrevious(command, outcome.code)"
                      [attr.aria-label]="
                        outcome.label +
                        ': ' +
                        (previousStepChoices.length === 1
                          ? 'Return to previous step, ' +
                            destinationLabel(previousStepChoices[0].id)
                          : 'Choose an earlier step to return to')
                      "
                    >
                      {{
                        previousStepChoices.length === 1
                          ? "Return to previous step"
                          : "Return to an earlier step…"
                      }}
                    </button>
                    <span *ngIf="previousStepChoices.length === 1" class="hint"
                      >{{ destinationLabel(previousStepChoices[0].id) }} · opens
                      a fresh visit</span
                    >
                    <span *ngIf="previousStepChoices.length > 1" class="hint"
                      >Several paths lead here. Choose the work step to
                      revisit.</span
                    >
                  </div>
                  <p
                    *ngIf="
                      destination.requiresPathInspection ||
                      destination.state === 'unselected' ||
                      destination.state === 'completion' ||
                      outcomeReturns(command).has(outcome.code)
                    "
                    class="route-explanation"
                    [class.issue]="
                      destination.requiresPathInspection ||
                      destination.state === 'unselected'
                    "
                  >
                    {{ destination.sentence }}
                  </p>
                  <p
                    *ngIf="
                      outcomeReturns(command).has(outcome.code) &&
                      !outcomeDestinations(command, outcome.code).length
                    "
                    class="issue"
                  >
                    No earlier work step is reachable on the forward path.
                  </p>
                </ng-container>
              </fieldset>
                      <div class="route-detail-links">
                        <button uiButton [text]="true" type="button" [disabled]="loading || !!routeInspectionIssue(command) || (!outcome.destinationNodeId && !routeChangesPending())" (click)="showSelectedOutcomePath()">View selected path on process map</button>
                        <button uiButton [text]="true" type="button" *ngIf="installed.completesStep === false" (click)="showSelectedOutcomeReason()">Reason policy in Work</button>
                        <button uiButton [text]="true" type="button" (click)="showRequirements()">Review completion requirements</button>
                      </div>
                    </div>
                  </ui-panel>
                </ng-container>
                <ng-template #unavailableOutcome>
                  <ui-panel panelTitle="Result unavailable" [noGrow]="true"><p class="route-detail-body" role="status">The selected result is missing or ambiguous. Choose a current result or inspect the saved workflow paths.</p></ui-panel>
                </ng-template>
              </div>
              <div
                *ngIf="
                  hasPendingChanges() ||
                  (!routeInspectionIssue(command) &&
                    (!immediateRoutingChanges || routeIssue(command)))
                "
                class="route-actions"
              >
                <button
                  uiButton
                  severity="primary"
                  [outlined]="false"
                  type="button"
                  class="primary"
                  (click)="preparingReviewDecision ? reopenReviewSetupDialog() : applyOutcomes(command)"
                  [disabled]="
                    disabled ||
                    loading ||
                    !!routeInspectionIssue(command) ||
                    (!hasPendingChanges() && !routeIssue(command))
                  "
                >
                  {{
                    preparingReviewDecision
                      ? "Review staged setup"
                      : "Apply routes"
                  }}
                </button>
                <button
                  uiButton
                  type="button"
                  (click)="discardRouteChanges()"
                  [disabled]="!routeChangesPending()"
                >
                  {{
                    preparingReviewDecision
                      ? "Discard review setup"
                      : "Discard route changes"
                  }}
                </button>
              </div>
            </ng-container>
            <ng-template #missingOutcomes>
              <p role="status">
                Restore the matching module to edit these outcomes. Their saved
                settings are preserved.
              </p>
              <article
                *ngFor="let outcome of outcomes(command); trackBy: trackOutcome"
                class="unavailable-route"
              >
                <strong>{{ outcome.label || outcome.code }}</strong>
                <span>{{ outcomeDestination(command, outcome).label }}</span>
                <small>{{
                  outcomeDestination(command, outcome).sentence
                }}</small>
              </article>
            </ng-template>
          </ng-container>
        </ng-container>
        <div *ngIf="selection.kind === 'next'" class="next-step-settings">
          <details *ngIf="!hasOutcomes" class="review-setup-disclosure">
            <summary>Add a review decision</summary>
          <ui-panel
            panelTitle="Does this step need a review decision?"
            [noGrow]="true"
          >
            <div class="review-setup">
              <p>
                Add <strong>Approved</strong> and
                <strong>Changes required</strong> results here, then choose
                where each goes. Changes required can return the process to an
                earlier step.
              </p>
              <button
                uiButton
                type="button"
                severity="primary"
                [outlined]="false"
                (click)="addReviewDecision()"
                data-review-setup-trigger="add"
                [disabled]="
                  disabled ||
                  loading ||
                  workEditingUnavailable ||
                  !reviewDecisionAvailable
                "
              >
                Add review decision
              </button>
              <p *ngIf="!reviewDecisionAvailable" class="hint">
                Review decision setup is unavailable from the installed actions.
                Reload the editor after the application is updated.
              </p>
              <p *ngIf="!previousStepChoices.length" class="hint">
                A return needs an earlier work step connected to this step. This
                step can still send its review results forward.
              </p>
            </div>
          </ui-panel>
          </details>
          <p *ngIf="hasSavedEvidenceActions" class="route-context">
            Saving answers, files or a review keeps this step open. Destinations
            apply after {{ completionTrigger }} and its completion checks.
          </p>
          <ng-container *ngIf="nextRoute as route">
            <div class="route-workspace" [class.route-needs-attention]="route.state !== 'direct'" data-direct-route-workspace>
              <ui-panel panelTitle="Routes" [noGrow]="true" class="route-list-panel">
                <nav aria-label="Continuation route" class="route-list">
                  <button uiButton [wrap]="true" [text]="true" [outlined]="false" type="button" class="route-list-row route-list-row--selected"
                    data-direct-route aria-pressed="true" (click)="selectNext()">
                    <span class="route-list-row__text"><strong>After {{ completionTrigger }}</strong><span>{{ route.label }}</span><small *ngIf="route.state === 'inspect'">Needs inspection</small></span>
                  </button>
                </nav>
              </ui-panel>
              <ui-panel panelTitle="After completion" [noGrow]="true" class="route-detail-panel">
                <div class="route-detail-body" data-direct-route-detail>
            <p
              class="route-explanation"
              [class.issue]="route.state !== 'direct'"
            >
              {{ route.sentence }}
            </p>
            <button
              uiButton
              [text]="true"
              [outlined]="false"
              *ngIf="route.state === 'inspect'; else directDestination"
              type="button"
              (click)="showPaths()"
            >
              Inspect workflow paths
            </button>
            <ng-template #directDestination>
              <label
                >Destination after completion
                <select
                  uiControl
                  #nextStepSelect #nextModel="ngModel"
                  aria-label="Next step"
                  [ngModel]="nextDestination"
                  (ngModelChange)="setSelectedNext($event, nextStepSelect, nextModel)"
                  [disabled]="disabled || loading || workEditingUnavailable"
                >
                  <option value="" disabled>Choose destination</option>
                  <option
                    *ngFor="let target of forwardDestinations"
                    [value]="target.id"
                  >
                    {{ destinationLabel(target.id) }}
                  </option>
                </select>
              </label>
            </ng-template>
                  <p class="hint">Choosing a destination uses an existing step; it does not create one.</p>
                  <div class="route-detail-links">
                    <button uiButton [text]="true" type="button" *ngIf="route.state === 'direct'" (click)="showDirectPath()">View selected path on process map</button>
                    <button uiButton [text]="true" type="button" (click)="showRequirements()">Review completion requirements</button>
                  </div>
                </div>
              </ui-panel>
            </div>
          </ng-container>
        </div>
      </div>
    </section>
  </div>
  <div *ngIf="scope === 'work' && overview" class="work-overview-components" data-work-component-overview>
    <p *ngIf="!workOverviewCountsKnown" role="status">Matching module metadata is needed to confirm the saved form and action counts. Saved declarations are retained below.</p>
    <ng-template #formOverviewActions><button uiButton [size]="undefined" [wrap]="true" [text]="true" type="button" class="work-overview-components__manage" [disabled]="loading" (click)="workSectionRequested.emit('form')">Manage forms</button></ng-template>
    <ui-panel panelTitle="Forms" [headerActionsTemplate]="formOverviewActions" [noGrow]="true" [totalCount]="workOverviewCountsKnown ? workFormCommands.length : undefined">
      <div class="work-overview-components__body">
        <ul *ngIf="workFormCommands.length"><li *ngFor="let command of workFormCommands; trackBy: trackCommand"><strong>{{ command.captureForm?.title || workOverviewLabel(command) }}</strong><p>{{ workOverviewFormSummary(command) }}</p></li></ul>
        <p *ngIf="!workFormCommands.length">{{ workOverviewCountsKnown ? 'No forms added.' : 'No form-bearing declaration identified yet; matching metadata may identify additional saved forms.' }}</p>
      </div>
    </ui-panel>
    <ng-template #actionOverviewActions><button uiButton [size]="undefined" [wrap]="true" [text]="true" type="button" class="work-overview-components__manage" [disabled]="loading" (click)="workSectionRequested.emit('action')">Manage actions</button></ng-template>
    <ui-panel panelTitle="Actions" [headerActionsTemplate]="actionOverviewActions" [noGrow]="true" [totalCount]="workOverviewCountsKnown ? workActionCommands.length : undefined">
      <div class="work-overview-components__body">
        <ul *ngIf="workActionCommands.length"><li *ngFor="let command of workActionCommands; trackBy: trackCommand"><strong>{{ workOverviewLabel(command) }}</strong><p>{{ workOverviewActionSummary(command) }}</p></li></ul>
        <p *ngIf="!workActionCommands.length">{{ workOverviewCountsKnown ? 'No actions added.' : 'No separate action declaration identified yet; matching metadata is needed to confirm the partition.' }}</p>
      </div>
    </ui-panel>
  </div>
  <section
    *ngIf="scope === 'work' && node.declaration"
    [hidden]="overview || (contextualWorkHeader && workLibraryKind === 'form')"
    class="work-components"
    aria-label="Forms and actions"
  >
    <ui-panel [headerTemplate]="formListHeader" [noGrow]="true" class="work-component-group" aria-label="Step forms" [hidden]="workLibraryKind !== 'form'">
      <ng-template #formListHeader><header class="work-group-header">
        <h3>Forms <span class="work-group-count">{{ workFormCommands.length }}</span></h3>
        <button
          uiButton
          type="button" *ngIf="!contextualWorkHeader"
          (click)="selectLibrary('form')"
          [disabled]="disabled || loading || workEditingUnavailable"
        >
          Add form
        </button>
      </header></ng-template>
      <div class="work-component-list">
        <button
          uiButton
          [text]="true"
          [outlined]="false"
          type="button"
          *ngFor="let command of workFormCommands; trackBy: trackCommand"
          (click)="selectForm(command)"
          [attr.aria-pressed]="
            selection.kind === 'form' &&
            selection.commandId === identity(command)
          "
          [attr.aria-label]="'Edit ' + label(command) + ' form'"
          class="work-component-row"
        >
          <strong>{{ command.captureForm?.title || label(command) }}</strong
          ><small>{{
            contract(command)
              ? formFieldSummary(command)
              : "Module unavailable · saved form preserved"
          }}</small>
        </button>
        <p *ngIf="!workFormCommands.length" class="hint">No forms added.</p>
      </div>
    </ui-panel>
    <ui-panel [headerTemplate]="actionListHeader" [noGrow]="true" class="work-component-group" aria-label="Step actions" [hidden]="workLibraryKind !== 'action'">
      <ng-template #actionListHeader><header class="work-group-header">
        <h3>Actions <span class="work-group-count">{{ workActionCommands.length }}</span></h3>
        <button
          uiButton
          type="button" *ngIf="!contextualWorkHeader"
          (click)="selectLibrary('action')"
          [disabled]="disabled || loading || workEditingUnavailable"
        >
          Add action
        </button>
      </header></ng-template>
      <div class="work-component-list">
        <button
          uiButton
          [text]="true"
          [outlined]="false"
          type="button"
          *ngFor="let command of workActionCommands; trackBy: trackCommand"
          (click)="selectAction(command)"
          [attr.aria-pressed]="
            selection.kind === 'action' &&
            selection.commandId === identity(command)
          "
          [attr.aria-label]="'Edit ' + label(command) + ' action'"
          class="work-component-row"
        >
          <strong>{{ label(command) }}</strong
          ><small *ngIf="!contract(command) || actionSummary(command)">{{
            contract(command)
              ? actionSummary(command)
              : "Module unavailable · saved action preserved"
          }}</small>
        </button>
        <p *ngIf="!workActionCommands.length" class="hint">No actions added.</p>
      </div>
    </ui-panel>
  </section>
  <section
    *ngIf="
      catalog &&
      scope === 'detail' &&
      !hideDetailEditor &&
      !inspectorOnly &&
      formCommands.length
    "
    aria-label="Configure form fields"
  >
    <details
      *ngFor="let command of formCommands; trackBy: trackCommand"
      class="field-configuration"
      [open]="isMainForm(command)"
    >
      <summary>
        {{ label(command) }} ·
        {{
          contract(command)?.supportsCaptureForm
            ? "Form builder"
            : "Form fields"
        }}
      </summary>
      <ng-container
        *ngIf="contract(command) as installed; else unavailableForm"
      >
        <p *ngIf="formVersionUnavailable(command)" role="status">This saved form version is unavailable in this workflow format. Its settings are preserved.</p>
        <phms-workflow-capture-form-editor
          *ngIf="installed.supportsCaptureForm"
          [form]="command.captureForm || null"
          [copies]="captureFormCopies"
          [disabled]="disabled || loading || workEditingUnavailable || formVersionUnavailable(command)"
          (formChange)="setCaptureForm(command, $event)"
        />
        <phms-workflow-form-fields-editor
          *ngIf="!installed.supportsCaptureForm"
          [command]="command"
          [installed]="installed"
          [disabled]="disabled || loading || workEditingUnavailable || formVersionUnavailable(command)"
          (configurationChange)="setFormConfiguration(command, $event)"
        />
      </ng-container>
      <ng-template #unavailableForm
        ><p>
          Restore the matching module to edit this action’s saved fields.
        </p></ng-template
      >
    </details>
  </section>
  <div
    *ngIf="
      catalog && scope === 'dashboard' && !hideDashboardPicker && !inspectorOnly
    "
    class="component-picker"
  >
    <label
      >Available worklist<select
        uiControl
        aria-label="Available worklist"
        [(ngModel)]="selectedView"
        [disabled]="disabled || loading || workEditingUnavailable"
      >
        <option value="">Choose an installed view</option>
        <option *ngFor="let view of catalog.views" [value]="viewIdentity(view)">
          {{ view.label }}
        </option>
      </select></label
    >
    <button
      uiButton
      type="button"
      (click)="addView()"
      [disabled]="
        disabled || loading || workEditingUnavailable || !selectedView
      "
    >
      Add dashboard
    </button>
  </div>
  <section
    *ngIf="
      ((catalog && inspectorOnly) ||
        (scope === 'work' &&
          node.declaration &&
          (selection.kind === 'library' ||
            selection.kind === 'action' ||
            selection.kind === 'form')))
    "
    class="action-inspector"
    [class.action-inspector--focused]="contextualWorkHeader && (formActionSettings || (selectedCommand && isFinalCompletion(selectedCommand)))"
    [hidden]="scope === 'work' && overview"
    [attr.aria-label]="scope === 'work' && selection.kind === 'form' && !formActionSettings ? 'Form editor' : 'Staff action settings'"
  >
    <h3 [hidden]="contextualWorkHeader && (selection.kind === 'form' || formActionSettings || (selectedCommand && isFinalCompletion(selectedCommand)))" tabindex="-1" [attr.data-owner-focus]="contextualWorkHeader ? 'action-detail' : 'work-selection'">{{ inspectorTitle }}</h3>
    <div
      *ngIf="selection.kind === 'library' && scope !== 'work'"
      class="action-library"
      aria-label="Available staff actions"
    >
      <article *ngFor="let choice of libraryChoices; trackBy: trackLibraryChoice" class="library-action">
        <ng-container *ngIf="choice.command as item">
        <div>
          <strong>{{ item.label }}</strong>
          <p>{{ item.description }}</p>
          <small *ngIf="item.exclusiveCompletion">Completes this step</small>
        </div>
        <p *ngIf="choice.reason" class="compatibility-reason">
          {{ choice.reason }}
        </p>
        <button
          uiButton
          type="button"
          (click)="addAction(item)"
          [disabled]="
            disabled ||
            loading ||
            workEditingUnavailable ||
            !!choice.reason
          "
          [attr.aria-label]="'Add ' + item.label"
        >
          Add action
        </button>
        </ng-container>
      </article>
      <p *ngIf="!loading && catalog && !libraryChoices.length" class="hint" role="status">
        No additional actions are available for this step.
      </p>
    </div>
    <ng-container *ngIf="selectedCommand as command">
      <ng-container
        *ngIf="
          selection.kind === 'action' ||
          (scope === 'work' && selection.kind === 'form')
        "
      >
        <ng-container
          *ngIf="exactActionContract(command) as installed; else missingContract"
        >
          <ng-container *ngIf="scope === 'work' && selection.kind === 'form'">
            <div class="work-form-editor" [hidden]="formActionSettings">
            <p *ngIf="formVersionUnavailable(command)" role="status">This saved form version is unavailable in this workflow format. Its settings are preserved.</p>
            <phms-workflow-work-form-editor
              [document]="document" [node]="node" [command]="command" [installed]="installed" [copies]="captureFormCopies"
              [providedTitle]="providedFormTitle(command)"
              [layoutEnableReason]="formLayoutEnableReason(command)"
              [lookupOwner]="currentFormLookupOwner" [lookupContext]="currentFormLookupContext" [editContext]="currentFormEditContext" [editAvailable]="currentFormEditAvailable"
              [providedAuthoringContext]="currentProvidedFormAuthoringContext"
              [active]="active && !overview && !formActionSettings && !formSetup" [resetVersion]="resetVersion" [contextKey]="formOwnerContext()"
              [disabled]="disabled || loading || !!formSetup || workEditingUnavailable || formVersionUnavailable(command)"
              (captureFormChange)="setCaptureForm($event.command, $event.form)"
              (configurationChange)="setFormConfiguration($event.command, $event.configuration)"
              (layoutChangeRequested)="changeFormLayout($event.command, $event.fieldId, $event.change)"
              (enableLayoutRequested)="enableFormLayout(command)"
              (lookupSourceChange)="setCaptureLookupSource(command, $event)"
              (providedLookupSourceChange)="setProvidedLookupSource($event)"
              (openActionSettings)="openFormActionSettings(command)"
            />
            </div>
            <div *ngIf="initializedFormSettings.has(identity(command))" class="form-action-settings" [hidden]="!formActionSettings">
              <ng-container
                *ngTemplateOutlet="
                  actionSettings;
                  context: { $implicit: command, installed: installed }
                "
              />
            </div>
          </ng-container>
          <ng-container *ngIf="selection.kind === 'action'">
            <ng-container
              *ngTemplateOutlet="
                actionSettings;
                context: { $implicit: command, installed: installed }
              "
            />
          </ng-container>
        </ng-container>
        <ng-template #missingContract
          ><p role="status">
            This exact module is unavailable. Its saved settings are preserved;
            restore the module to edit them.
          </p><details class="technical-details"><summary>Module details</summary><pre>{{ command | json }}</pre></details></ng-template
        >
        <div class="remove-action">
          <button
            uiButton
            severity="danger"
            [text]="true"
            [outlined]="false"
            type="button"
            (click)="removeAction(command)"
            [disabled]="disabled || loading || workEditingUnavailable || !!removalReason(command)"
            [attr.aria-label]="'Remove ' + label(command)"
          >
            {{ selection.kind === 'form' ? 'Remove form' : 'Remove action' }}
          </button>
          <p *ngIf="removalReason(command)" class="compatibility-reason">{{ removalReason(command) }}</p>
        </div>
      </ng-container>
    </ng-container>
  </section>
  <ng-template #actionSettings let-command let-installed="installed">
    <ng-container *ngIf="scope === 'work' && isFinalCompletion(command); else generalActionSettings">
      <ng-template #completeActionHeader><h4 class="action-detail-title">{{ label(command) }}</h4></ng-template>
      <ui-panel [headerTemplate]="completeActionHeader" [noGrow]="true" class="complete-action-panel">
        <div class="action-detail-body">
          <p>Checks every completion requirement, then uses this step's configured route.</p>
          <section aria-label="Completion requirements">
            <h4>Completion requirements</h4>
            <ul *ngIf="node.declaration?.behavior?.completionRequirements?.length"><li *ngFor="let row of node.declaration!.behavior.completionRequirements">{{ completionRequirementLabel(row) }}</li></ul>
            <p *ngIf="!node.declaration?.behavior?.completionRequirements?.length">No authored completion requirements.</p>
            <button uiButton [size]="undefined" [text]="true" type="button" (click)="showRequirements()">Manage requirements</button>
          </section>
          <section aria-label="Routing">
            <h4>Routing</h4><p>Choose where work goes after completion.</p>
            <button uiButton [size]="undefined" [outlined]="true" type="button" (click)="showPaths()">Open Routing</button>
          </section>
          <details class="technical-details"><summary>Module details</summary><pre>{{ command.capability | json }}</pre></details>
        </div>
      </ui-panel>
    </ng-container>
    <ng-template #generalActionSettings>
    <ng-container *ngIf="commandAuthoringReason(command) as reason; else editableActionSettings">
      <p role="status">{{ reason }}</p>
      <button *ngIf="installed.form" uiButton type="button" (click)="editForm(command)" [disabled]="loading">Inspect form</button>
      <details class="technical-details"><summary>Module details</summary><pre>{{ command | json }}</pre></details>
    </ng-container>
    <ng-template #editableActionSettings>
    <p *ngIf="scope === 'work' && formActionSettings" class="action-description">{{ installed.description || 'Saves without completing this step.' }}</p>
    <p *ngIf="scope === 'work' && formActionSettings && installed.completesStep === false && command.outcomes.length">Recording a result saves evidence without completing the step. Complete step later checks requirements and uses Routing.</p>
    <details
      *ngIf="!formActionSettings && (installed.description || installed.exclusiveCompletion || installed.completesStep === false)"
      class="action-help"
    >
      <summary>How this action works</summary>
      <p *ngIf="installed.description">{{ installed.description }}</p>
      <p *ngIf="installed.exclusiveCompletion">
        Completes the step when submitted.
      </p>
      <p *ngIf="installed.completesStep === false">
        Saves without completing the step. Requirements control completion.
        <ng-container *ngIf="command.outcomes.length">
          Recorded results follow the step's next path when it completes.
        </ng-container>
      </p>
    </details>
    <div
      *ngIf="
        installed.form &&
        !isFinalCompletion(command) &&
        (selection.kind !== 'form' || formActionSettings)
      "
      class="form-choice"
    >
      <div>
        <strong>Form</strong><small>{{ formSummary(command) }}</small>
      </div>
      <button
        uiButton
        type="button"
        (click)="editForm(command)"
        [disabled]="loading"
      >
        Edit form
      </button>
    </div>
    <ng-template #moduleChecksHeader><h4 class="action-detail-title">Checks defined by the module</h4></ng-template>
    <ui-panel *ngIf="installed.requirements.length" [headerTemplate]="moduleChecksHeader" [noGrow]="true" class="action-settings-panel">
    <fieldset
      [disabled]="disabled || loading || workEditingUnavailable"
      class="requirements"
    >
      <legend>Module checks</legend>
      <ng-container *ngFor="let rule of installed.requirements">
        <div *ngIf="rule.mandatory; else optionalCheck" class="locked-check">
          <span class="lock-marker" aria-hidden="true">▣</span
          ><span class="locked-check__label"
            >{{ rule.label }}<small>Required</small
            ><small
              *ngIf="!command.requirements.includes(rule.code)"
              class="issue"
              >Missing from this action</small>
            <small *ngIf="moduleCheckExplanation(command, rule.code)">{{ moduleCheckExplanation(command, rule.code) }}</small></span>
        </div>
        <ng-template #optionalCheck
          ><label class="check"
            ><input
              uiControl
              type="checkbox"
              [checked]="command.requirements.includes(rule.code)"
              (change)="
                setRequirement(command, rule.code, $any($event.target).checked)
              "
            />{{ rule.label }}</label
          ></ng-template
        >
      </ng-container>
      <button
        uiButton
        *ngIf="missingRequiredChecks(command).length"
        type="button"
        (click)="restoreRequiredChecks(command)"
        [disabled]="disabled || loading || workEditingUnavailable"
      >
        Restore required checks
      </button>
    </fieldset>
    </ui-panel>
    <button
      uiButton
      [text]="true"
      [outlined]="false"
      *ngIf="command.outcomes.length && installed.completesStep !== false"
      type="button"
      (click)="requestOutcomes(command)"
    >
      Configure outcomes
    </button>
    <ng-template #recordedResultsHeader><h4 class="action-detail-title">Recorded results</h4></ng-template>
    <ui-panel *ngIf="command.outcomes.length && installed.completesStep === false" [headerTemplate]="recordedResultsHeader" [noGrow]="true" class="action-settings-panel">
    <fieldset aria-label="Recorded results">
      <label *ngFor="let result of command.outcomes" class="recorded-result">
        {{ result.label }} — reason
        <select
          *ngIf="recordedReasonPolicies(command, result.code).length > 1; else fixedReasonPolicy"
          uiControl
          [attr.aria-label]="result.label + ' reason'"
          [disabled]="disabled || loading || workEditingUnavailable"
          [ngModel]="result.reasonPolicy"
          (ngModelChange)="
            setRecordedReasonPolicy(command, result.code, $event)
          "
        >
          <option *ngIf="!recordedReasonPolicies(command, result.code).includes(result.reasonPolicy)" [value]="result.reasonPolicy">Saved unavailable policy: {{ result.reasonPolicy }}</option>
          <option
            *ngFor="let policy of recordedReasonPolicies(command, result.code)"
            [value]="policy"
          >
            {{ policy === "required" ? "Required" : "Optional" }}
          </option>
        </select>
        <small *ngIf="recordedReasonPolicies(command, result.code).length > 1 && !recordedReasonPolicies(command, result.code).includes(result.reasonPolicy)" role="status">The saved reason policy is unavailable. It is retained until you choose a supported policy.</small>
        <ng-template #fixedReasonPolicy>
          <span class="fixed-reason-policy">{{ recordedReasonPolicies(command, result.code)[0] === 'required' ? 'Required' : recordedReasonPolicies(command, result.code)[0] === 'optional' ? 'Optional' : 'Saved policy: ' + result.reasonPolicy }}</span>
          <small *ngIf="recordedReasonPolicies(command, result.code).length === 1">Defined by the module.</small>
          <span *ngIf="recordedReasonPolicies(command, result.code).length === 1 && !recordedReasonPolicies(command, result.code).includes(result.reasonPolicy)" role="alert">Saved policy: {{ result.reasonPolicy }}. It differs from the fixed module policy.</span>
        </ng-template>
      </label>
    </fieldset>
    </ui-panel>
    <div *ngIf="scope === 'work' && formActionSettings" class="action-routing-link"><p>{{ installed.completesStep === false ? 'Destinations apply after Complete step.' : installed.completesStep === true ? 'This action completes the step using its configured routes.' : 'Routing follows this action’s installed completion behavior.' }}</p><button uiButton [size]="undefined" [text]="true" type="button" (click)="showPaths()">Open Routing</button></div>
    <details class="technical-details">
      <summary>Module details</summary>
      <p>
        {{ command.capability.key.provider }} ·
        {{ command.capability.key.code }} · Version
        {{ command.capability.key.version }}
      </p>
      <pre>{{ command | json }}</pre>
    </details>
    <phms-workflow-action-data-editor
      *ngIf="!isFinalCompletion(command) && !isRestrictedProvidedLookup(command.capability) && supportsProcessData(document.payloadSchemaVersion)"
      [document]="document"
      [command]="command"
      [installed]="installed"
      [disabled]="disabled || loading || workEditingUnavailable"
      (pendingChangesChange)="onDataFlowPending($event)"
      (commandChange)="applyDataFlow(command, $event)"
    ></phms-workflow-action-data-editor>
    </ng-template>
    </ng-template>
  </ng-template>
</section>
